const DashboardConstantsEN = {
  dashboardUsersPaperTitle: 'Users',
  dashboardUsersPaperSubTitle: 'All Active Users',
  dashboardMediasPaperTitle: 'Media',
  dashboardMediasPaperSubTitle: 'Total Published Media',
  dashboardOrdersPaperTitle: 'Orders',
  dashboardOrdersPaperSubTitle: 'Total Orders Received',
  viewAllLabel: 'View All',

  signUpTableLabel: 'Latest User Requests',
  signupRequestCountryColumn: 'Country',
  signupRequestCompanyNameColumn: 'Company Name',
  signupRequestPurposeOfUseColumn: 'Purpose Of Use',
  mediaTableLabel: 'Latest Published Media',
  proposalRequestsTableLabel: 'Latest Proposal Requests',
  ordersTableLabel:'Latest Orders',
};

export default DashboardConstantsEN;
